export const HONORED_OPT_OUT = 'Your Opt-Out Preference Signal has been honored.';
export const HONORED_OPT_OUT_COLOR = 'font-size: 18px; color: rgb(0, 138, 26)';
export const NO_OPT_OUT = 'No Opt-Out Preference Signal has been detected.';
export const NO_OPT_OUT_COLOR = 'font-size: 18px; color: rgb(180, 83, 3)';
export const CHANGE_TXT_QUERY = '#gpc_signal_indicator div';
export const CHANGE_COLOR_ID = 'gpc_signal_indicator';
export const INTERVAL = 2000;
